import angular from 'angular';
import uiRouter from 'angular-ui-router';
import unauthorizedComponent from './unauthorized.component';

let unauthorizedModule = angular.module('unauthorized', [
  uiRouter
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";

  $stateProvider
    .state('unauthorized', {
      url: '/unauthorized',
      component: 'unauthorized',
      params: {
        msg: ''
      },
    });
})

.component('unauthorized', unauthorizedComponent)

.name;

export default unauthorizedModule;



// WEBPACK FOOTER //
// ./client/app/components/unauthorized/unauthorized.js